export const defaultFileUpload = [
  {
    text: "We use the create method to turn a",
    code: "<input type='file'>",
  },
  {
    text: " into a FilePond drop area.",
    code: "[https://pqina.nl/filepond/]",
  },
];

export const imagePreviewData = [
  {
    text: "We use the create method to turn a",
    code: "<input type='file'>",
  },
  {
    text: " into a FilePond drop area.",
    code: "[https://pqina.nl/filepond/]",
  },
];

export const fileUploadData = [
  {
    text: "Use the ",
    code: ".dropzone ",
  },
  {
    text: "class through create upload files.",
    code: "[https://www.dropzone.dev/].",
  },
];
